import { useContext, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { CartContext } from "../../context/CartContext";
import { Link, useNavigate } from "react-router-dom";
import '../Cart/Cart.css';

const Cart = () => {
    const { cartEcommerce, removeItem, clearCart, getTotalcarrito } = useContext(CartContext);
    const navigate = useNavigate();
    const [isClearing, setIsClearing] = useState(false);
    const totalCompra = getTotalcarrito();

    const handleClearCart = async () => {
        setIsClearing(true);
        clearCart();
        
        // Simular procesamiento y luego redirigir
        setTimeout(() => {
            navigate('/');
            setIsClearing(false);
        }, 1500);
    };

    // Mostrar loader mientras se vacía el carrito
    if (isClearing) {
        return (
            <div className="cart-container">
                <div className="spinner-container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                    <Spinner animation="border" variant="danger" className='spinner' />
                    <p style={{ marginTop: '20px', fontSize: '18px' }}>Vaciando carrito...</p>
                </div>
            </div>
        );
    }

    if (!Array.isArray(cartEcommerce) || cartEcommerce.length === 0) {
        return (
            <div className="cart-container">
                <div className="cart-empty">
                    <img 
                        src={'../images/imagenCarritovacio.png'} 
                        alt='Carrito vacío'
                        width="200"
                        height="200"
                        loading="lazy"
                    />
                    <h2>Tu carrito está vacío</h2>
                    <p>¿Todavía no sabes qué comprar? ¡Tenemos los productos que necesitas!</p>
                    <Button as={Link} to='/' className="btn-primary">
                        Explorar productos
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="cart-container">
            <h1>Mi Carrito de Compras</h1>
            
            <div className="cart-items">
                <div className="cart-header">
                    <span>Producto</span>
                    <span>Cantidad</span>
                    <span>Precio</span>
                    <span>Subtotal</span>
                    <span>Acción</span>
                </div>
                
                {cartEcommerce.map(prod => (
                    <div key={prod.id} className="cart-item">
                        <span className="cart-item-name">{prod.name}</span>
                        <span className="cart-item-quantity">{prod.quantityToadd}</span>
                        <span className="cart-item-price">${prod.price.toLocaleString()}</span>
                        <span className="cart-item-subtotal">
                            ${(prod.price * prod.quantityToadd).toLocaleString()}
                        </span>
                        <Button 
                            className="btn-remove" 
                            onClick={() => removeItem(prod.id)}
                        >
                            Eliminar
                        </Button>
                    </div>
                ))}
            </div>
            
            <div className="cart-summary">
                <div className="cart-total">
                    <span>Total a pagar:</span>
                    <span>${totalCompra.toLocaleString()}</span>
                </div>
            </div>
            
            <div className="cart-actions">
                <Button as={Link} to='/' className="btn-outline">
                    Seguir comprando
                </Button>
                <Button onClick={handleClearCart} className="btn-clear" disabled={isClearing}>
                    {isClearing ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{ marginRight: '8px' }}
                            />
                            Vaciando...
                        </>
                    ) : (
                        'Vaciar carrito'
                    )}
                </Button>
                <Button as={Link} to='/checkout' className="btn-checkout">
                    Finalizar compra
                </Button>
            </div>
        </div>
    );
}

export default Cart;
